import * as React from "react";
import ICheckBoxWidgetProps from "./ICheckBoxWidgetPropsType";
import "../../../assets/sass/widgets/checkBox.scss";
import { handleEnter } from "../../utils/utils";
interface IcheckBoxState {
    checked: boolean;
}
/**
 * @class CheckBox
 * @description
 * This component renders the checkbox element and binds the action that is passed as the parameter to the component
 * @category Widgets
 */
class CheckBoxWidget extends React.Component<ICheckBoxWidgetProps, IcheckBoxState, {}> {
    constructor(props: ICheckBoxWidgetProps) {
        super(props);
    }
    componentDidMount() {
        const defaultValue =
            (this.props.schema.default && this.props.schema.default.toLowerCase()) || this.props.schema.default || "";
        const { value, onChange } = this.props;
        if ((defaultValue === "true" || defaultValue === true) && value !== false) {
            setTimeout(function () {
                onChange(true);
            }, 1);
        }
    }
    componentDidUpdate(prevProps: any, prevState: any) {
        const { value: prevValue } = prevProps;
        const { value, schema, onChange } = this.props;
        const defaultValue =
            (this.props.schema.default && this.props.schema.default.toLowerCase()) || this.props.schema.default || "";
        if (prevValue !== value) {
            // triggered onchange of a radio button
            onChange(value);
        } else if ((defaultValue === "true" || defaultValue === true) && value !== false) {
            setTimeout(function () {
                schema.default ? onChange(schema.default) : onChange("");
            }, 1);
        }
    }
    handleCLick = (e) => {
        this.props.onChange(e.target.checked);
    };
    render() {
        const { schema, id } = this.props;
        const checkBoxVal = this.props.value;
        return (
            <>
                <label>{schema.const.label ? schema.const.label : ""}</label>
                <label
                    tabIndex={schema.const.tabIndex}
                    onKeyPress={handleEnter}
                    className={`gaf-checkbox  ${checkBoxVal ? "checked" : "unchecked"}`}
                >
                    <input
                        checked={this.props.value}
                        id={id}
                        tabIndex={-1}
                        type="checkbox"
                        className="hide-checkbox"
                        onClick={this.handleCLick}
                    />
                </label>
            </>
        );
    }
}

export default CheckBoxWidget;
